import { FunctionComponent, useEffect, useState } from "react";
import "./CaregiverInfo.css";
import editIcon from "../../assets/icons/edit.svg";
import "react-toastify/dist/ReactToastify.css";
import Card from "../../atoms/CardV2/Card";
import { RiHandHeartLine } from "react-icons/ri";
import Input from "../../atoms/Input/Input";
import Button from "../../atoms/Button/Button";
import Dropdown from "../../atoms/Dropdown";
import { PATIENT_RELATIONS } from "../../constants/common";

interface InfoProps {
  careGiverDetails: any;
  onSave?: (updatedDetails: any, userType: any) => void;
}

const CaregiverInfo: FunctionComponent<InfoProps> = ({
  careGiverDetails,
  onSave,
}) => {
  const [editedDetails, setEditedDetails] = useState<any>({});
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (careGiverDetails) {
      setEditedDetails(careGiverDetails);
    }
  }, [careGiverDetails]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement> | any) => {
    e?.preventDefault?.();
    setEditedDetails({ ...editedDetails, [e?.target?.name]: e?.target?.value });
  };

  const handleSave = async () => {
    try {
      onSave?.(editedDetails, "Caregiver");
    } catch (error) {}
  };

  return (
    <Card
      title="Caregiver Info"
      titleIcon={<RiHandHeartLine size={24} />}
      fullWidth={true}
      actionComponent={
        <Button variant="text" color="info" onClick={handleSave}>
          <img src={editIcon} alt="edit" />
          <span>{isSaving ? "Saving..." : "Save"}</span>
        </Button>
      }
    >
      <div className="caregiver-info-content">
        <Input
          label="Name*"
          name="cg_name"
          value={editedDetails.cg_name || ""}
          placeholder="Enter Name"
          onChange={handleChange}
        />

        <Input
          label="Phone Number*"
          name="cg_contact_no"
          value={editedDetails.cg_contact_no || ""}
          placeholder="Enter Number"
          onChange={handleChange}
        />

        <Dropdown 
          options={PATIENT_RELATIONS}
          onChange={(e: any) => handleChange({ target: { name: "cg_relation", value: e.target.value } })}
          value={editedDetails.cg_relation || ""}
          label="Relationship with user*"
        />

        {/* <Input
          label="Relationship with user*"
          name="cg_relation"
          value={editedDetails.cg_relation || ""}
          placeholder="Enter relation with patient"
          onChange={handleChange}
        /> */}
      </div>
    </Card>
  );
};

export default CaregiverInfo;
